import { render, staticRenderFns } from "./roleInCompany.vue?vue&type=template&id=7740cfe1"
import script from "./roleInCompany.vue?vue&type=script&lang=js"
export * from "./roleInCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports